import { PortaledModalFrame } from "src/components/common/PortaledModalFrame";

const TableOrderMOdal = ({ tableOrderDetails, isShowTableOrderModal }: any) => {
  return (
    <PortaledModalFrame onClose={isShowTableOrderModal} panelStyle={{ maxWidth: 400 }}>
      <div className="flex flex-col items-center gap-6 px-6 py-8">
        <h1 id="modal-title" className="text-center text-xl">
          Table Order
        </h1>
        <button
          type="button"
          className="flex h-9 w-full max-w-xs items-center justify-center rounded-xl bg-[#F5F5F6] px-8 text-xs text-black hover:bg-orange hover:text-white"
          onClick={isShowTableOrderModal}
        >
          Close
        </button>
      </div>
    </PortaledModalFrame>
  );
};

export default TableOrderMOdal;
